var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"button button--secondary",attrs:{"href":"#","disabled":_vm.showEdit,"id":"edit-shortcut"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleEdit.apply(null, arguments)}}},[_vm._v("Edit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }